module.exports = __webpack_public_path__ + "static/media/robosearch.dd9f6c4d.jpg";